import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { IMakeRequest } from '../../../../utils/request';
import { FeedbackPopup } from './index';

export const FeedbackPopupContainer = connect<
  {
    makeRequest: IMakeRequest;
    userEmail?: string;
  },
  {},
  {
    onClose(): void;
  }
>(
  (state: IAppState) => ({
    makeRequest: state.makeRequest,
    userEmail: state.user.isAuthenticated ? state.user.email : undefined,
  }),
  (dispatch: Dispatch) => ({}),
)(FeedbackPopup);
